import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Container, Row, Col, Form, Modal, Table, Stack, TabPane, OverlayTrigger, Tooltip, Image } from 'react-bootstrap';
import { AccountContext } from "./Account";
import LoadingOverlay from 'react-loading-overlay';
import PacmanLoader from 'react-spinners/PacmanLoader';

const Inicio = () => {
    const navigate = useNavigate();
    const { getSession, logout, usuario } = useContext(AccountContext);
    const [loading, setLoading] = useState(false);//usuario == null ? true : false

    useEffect(()=>{
        getSession().then((session)=>{
            console.log("SESSION INICIO", session);
        });
    }, []);

    const ingresarTrabajador = () => {
        navigate("/ingtrabajador");
    }

    const listaTrabajadores = () => {
        navigate("/trabajadores");
    }

    return (
        <LoadingOverlay active={loading} spinner={<PacmanLoader color="#8BC7FA" />} >
        <Container>
            <div className="bg-dark text-secondary px-4 py-5 text-center">
                <div className="py-5">
                    <Image className="d-block mx-auto mb-4" src="img/logo_2_192.png" width="57" height="57" />
                    <h1 className="display-5 fw-bold text-white">Sistema Reclutamiento</h1>
                    <div className="col-lg-6 mx-auto">
                        <p className="fs-5 mb-4">
                            Bienvenidos al sistema de reclutamiento de Ecora.
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-3"></div>
            <Row>
                {console.log("USUARIO INICIO", usuario)}
                {usuario != null ? usuario.perfiles.find(v => v.nombre === "Reclutador") && (
                    <Col className="text-center">
                        <Image src="img/agregar.png" roundedCircle width="140" height="140" />
                        <h2>Ingresar Trabajador</h2>
                        <p>Presione en el siguiente boton para ingresar un trabajador nuevo</p>
                        <Button variant="secondary" onClick={ingresarTrabajador}>Ingresar</Button>
                    </Col>
                ): ""}
                <Col className="text-center">
                    <Image src="img/lista.png" roundedCircle width="140" height="140" />
                    <h2>Ver Trabajadores</h2>
                    <p>Presiones en el siguiente boton para ver el listado de los trabajadores y sus avances</p>
                    <Button variant="secondary" onClick={listaTrabajadores}>Ver lista</Button>
                </Col>
            </Row>
        </Container>
        </LoadingOverlay>
    )
}

export default Inicio;